export default "__VITE_ASSET__02fc2e5a__"